// components/UserInfoForm.tsx
import React, { useState } from "react";

interface UserInfoFormProps {
  onSubmit: (userInfo: UserInfo) => void;
  language: "en" | "bg";
}

export interface UserInfo {
  firstName: string;
  lastName: string;
  birthDate: string;
}

export const UserInfoForm: React.FC<UserInfoFormProps> = ({
  onSubmit,
  language,
}) => {
  const [userInfo, setUserInfo] = useState<UserInfo>({
    firstName: "",
    lastName: "",
    birthDate: "",
  });

  const translations = {
    en: {
      firstName: "First Name",
      lastName: "Last Name",
      birthDate: "Birth Date",
      submit: "Start Quiz",
      required: "All fields are required",
    },
    bg: {
      firstName: "Име",
      lastName: "Фамилия",
      birthDate: "Дата на раждане",
      submit: "Започни теста",
      required: "Всички полета са задължителни",
    },
  };

  const t = translations[language];

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (userInfo.firstName && userInfo.lastName && userInfo.birthDate) {
      onSubmit(userInfo);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="xb-item--form contact-from row">
        <div className="col-lg-6">
          <div className="xb-item--field">
            <span className="icon icon-user"></span>
            <span className="wpcf7-form-control-wrap">
              <input
                id="firstName"
                className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                aria-required="true"
                aria-invalid="false"
                placeholder={t.firstName}
                value={userInfo.firstName}
                onChange={(e) =>
                  setUserInfo({ ...userInfo, firstName: e.target.value })
                }
                type="text"
                name="text-929"
              />
            </span>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="xb-item--field">
            <span className="icon icon-user"></span>
            <span className="wpcf7-form-control-wrap">
              <input
                id="lastName"
                className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                aria-required="true"
                aria-invalid="false"
                placeholder={t.lastName}
                value={userInfo.lastName}
                onChange={(e) =>
                  setUserInfo({ ...userInfo, lastName: e.target.value })
                }
                type="text"
                name="text-929"
              />
            </span>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="xb-item--field">
            <span className="icon icon-user"></span>
            <span className="wpcf7-form-control-wrap">
              <input
                type="date"
                id="lastName"
                className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                aria-required="true"
                aria-invalid="false"
                placeholder={t.birthDate}
                value={userInfo.birthDate}
                onChange={(e) =>
                  setUserInfo({ ...userInfo, birthDate: e.target.value })
                }
              />
            </span>
          </div>
        </div>
      </div>
      <button type="submit" className="pt-3 pb-3 thm-btn btn-primary">
        {t.submit}
      </button>
    </form>
  );
};
